import { EventBus } from "OK/EventBus";
import { IAuthPopupOpenParams, IOAuthErrorHandlerParams } from '@ok/interfaces/auth/IAuthPopupOpenParams';

const AUTH_LOGIN_POPUP = 'auth.login.popup';

const create = EventBus.factory(AUTH_LOGIN_POPUP);

export const AUTH_LOGIN_POPUP_OPEN = create<IAuthPopupOpenParams>('authLoginPopupOpen');

export const AUTH_LOGIN_POPUP_CLOSE = create('authLoginPopupClose');

export const OAUTH_ERROR_HANDLER = create<IOAuthErrorHandlerParams>('oauthErrorHandler');
